import { render, staticRenderFns } from "./AboutSwiper2.vue?vue&type=template&id=837f6542&scoped=true&"
import script from "./AboutSwiper2.vue?vue&type=script&lang=js&"
export * from "./AboutSwiper2.vue?vue&type=script&lang=js&"
import style0 from "./AboutSwiper2.vue?vue&type=style&index=0&id=837f6542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837f6542",
  null
  
)

export default component.exports